<template>
  <div>
    <div class="fullPageContent closed">
      <DashboardHeader 
         ref="dashboardHeader"
         v-bind:title="pageTitle" 
         v-bind:activeEl="activeEl"
         v-bind:tabs="tabs"
         @tabSelectedChange="tabSelectedChange($event)">
      </DashboardHeader>
      <section class="allP wp1200">
        <div v-if="isActive === 1">
          <Profile @resetOpacity="resetOpacity($event)" @setOpacity="setOpacity($event)"></Profile>
        </div>
        <div v-if="isActive === 2">
          <Activity @resetOpacity="resetOpacity($event)" @setOpacity="setOpacity($event)"></Activity>
        </div>
      </section>
    </div>
  </div>
</template>
<script>

import DashboardHeader from "./partials/DashboardHeader.vue";
import Profile from "./MyProfile/Profile.vue";
import Activity from "./MyProfile/Activity.vue";
import { formatDate } from "@/helpers";

export default {
  data() {
    return {
      activeEl:5,
      pageTitle:this.$t("profile.my_profile"),
      tabs:[
        {
          index:1,
          name:this.$t("profile.profile")
        },
         {
          index:2,
          name:this.$t("profile.activity")
        }
      ],
      isActive:1,
      points: {
        transactions: [],
      },
      notCompleted: true,
    };
  },
  computed: {},
  components: {
    DashboardHeader,
    Profile,
    Activity,
  },
  mounted() {
    this.loadTransactions();
    this.$store.dispatch("app/loader", false);
    this.activityActive();
  },
  methods: {
    activityActive(){
      if(this.$route.query.page === 'activity'){
          this.tabSelectedChange(2);
          this.$refs.dashboardHeader.tabActive = 2;
      }
    },
    loadTransactions() {
      let lang = this.$i18n.locale;
      this.$store.dispatch("user/points",lang);
    },
    formatDate,
    resetOpacity() {
      this.showModal = false;
    },
    setOpacity() {
      this.showModal = true;
    },
    tabSelectedChange(active) {
      this.isActive = active;
      if (active === 2) {
        this.loadTransactions();
      }
    },
  },
};
</script>

<style>
.vue-typer .custom.char.typed {
  color: #ffffff;
}
.vue-typer .custom.caret {
  display: none;
}

.modal-backdrop {
  opacity: 0.2;
}
</style>